import React, { useEffect } from "react"
import { connect } from "react-redux";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import { withMainLayout } from "../../view/LayoutHOCs";
import * as layoutService from "../../view/layoutService";
import * as deviceService from "../deviceService";
import * as changelogService from "../deviceChangelogService";
import ChangeDetailsHeader from "./ChangeDetailHeader";
import ChangeDetailsInfoSection from "./ChangeDetailsInfoSection";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Devices",
        redirectTo: "/devices",
    },
    {
        text: "Change Details",
        redirectTo: "/change-details",
    },
]

function ConfigurationChangesPage(props) {

    useEffect(() => {
        layoutService.setPageTitle("Configuration Changes")
        layoutService.setBreadcrumbs(breadcrumbs)
        deviceService.loadById(props.match.params.deviceId)
        changelogService.loadById(props.match.params.id)
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    return (
        <>
            <InfoBoxes />
            <ChangeDetailsHeader />
            <ChangeDetailsInfoSection />
        </>
    );
}


export default withMainLayout(connect()(ConfigurationChangesPage));